<template>
  <div class="awards">
    <b-container>
      <h1 class="section-title">{{$t('awards-section-title-1')}}</h1>
      <b-row class="awards-list">
        <li v-for="(award, index) in AwardsList" :key="index" class="list-group-item list-group-item-action flex-column align-items-start">
          <div class="d-flex w-100 justify-content-between">
            <h5>{{award.year}}</h5>
            <p class="mb-1">{{award.title}}</p>
          </div>
        </li>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import csvData from '../assets/content/awards.csv'

export default {
  name: 'Awards',
  data () {
    this.AwardsList = csvData
  },
  created () {
    console.log('loading csv', csvData)
  }
}
</script>

<style lang="scss" scoped>
  .awards {
    .platform-title-img {
      width: 50%;
      bottom: 30px;
      right: 30px;
    }

    .section-title {
      font-size: 2rem;
      font-weight: bold;
      margin-top: 60px;
      margin-bottom: 40px;
    }

    .awards-list {
      margin-bottom: 3rem;

      .list-group-item {
        border-left: none;
        border-right: none;
      }

      h5 {
        padding-right: 1rem;
      }

      p {
        text-align: right;
      }
    }
  }
</style>
